import { Eye, EyeOff } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'

type Props = {
  viewedAt: string | null
}

export function ViewedIndicator({ viewedAt }: Props) {
  const label = viewedAt
    ? `Visualizado em ${format(parseISO(viewedAt), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })}`
    : 'Não visualizado'

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex items-center justify-center cursor-help"
            style={{ color: viewedAt ? 'var(--ev-fg-faint)' : 'var(--ev-accent)' }}
            aria-label={label}
          >
            {viewedAt ? (
              <Eye size={15} strokeWidth={1.75} />
            ) : (
              <EyeOff size={15} strokeWidth={1.75} />
            )}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top">
          <p className="text-xs">{label}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
